import { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./style.module.scss"

export type CommandBarNavigationIconProps = HtmlHTMLAttributes<HTMLSpanElement>

export const CommandBarNavigationIcon = memo(forwardRef<HTMLSpanElement, CommandBarNavigationIconProps>((
  {
    children,
    className,
    ...props
  }, ref) => {
  return (
    <span
      className={classNames(
        className,
        styles.root, {
          [styles.shortcutText]: typeof children === "string"
        }
      )}
      {...props}
      ref={ref}
    >
      {children}
    </span>
  );
}));